module.exports = __webpack_public_path__ + "img/bell.9645dac4.svg";